import { queryKeys } from "@/constants/queryKeys";
import { useCustomerScopedQuery } from "@/hooks/useCustomerScopedQuery";
import { services } from "@/services/registry";
export const useMeteredUsage = (contractId, startDate, endDate, apiKeyId, enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.usage.metered(contractId, startDate, endDate, apiKeyId),
        queryFn: ({ customerId })=>{
            if (!contractId) {
                throw new Error("Contract ID is required");
            }
            return services.usageService.getMeteredUsage(contractId, startDate, endDate, apiKeyId, customerId);
        },
        enabled: enabled && !!contractId
    });
};
export const useDailyUsage = (contractId, startDate, endDate, apiKeyId, enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.usage.daily(contractId, startDate, endDate, apiKeyId),
        queryFn: ({ customerId })=>{
            if (!contractId) {
                throw new Error("Contract ID is required");
            }
            return services.usageService.getDailyAggregatedUsage(contractId, startDate, endDate, apiKeyId, customerId);
        },
        enabled: enabled && !!contractId
    });
};
export const useHourlyUsage = (contractId, dayUtc, apiKeyId, enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.usage.hourly(contractId, dayUtc, apiKeyId),
        queryFn: ({ customerId })=>{
            if (!contractId) {
                throw new Error("Contract ID is required");
            }
            return services.usageService.getHourlyUsage(contractId, dayUtc, apiKeyId, customerId);
        },
        enabled: enabled && !!contractId
    });
};
